<template>
  <div id="app" class="wrap" :style="contentWidth">
    <div class="IE-tips" v-if="isIE" :style="{ width: contentWidth }">
      IE浏览器不兼容当前网站，复制链接到其他浏览器打开
    </div>
    <!-- <guide-mask></guide-mask> -->
    <div class="content-wrap">
      <global-loading v-show="showLoading" />
      <expert-task-header v-if="isShowHeader"></expert-task-header>
      <!-- <keep-alive :include="aliveList"> -->
      <router-view style="flex: 1; height: 0" />
      <!-- </keep-alive> -->
    </div>
    <!-- <div class="st-commonwealth-player" ref="stCommonwealthPlayerId">
      <video
        ref="stCommonwealthPlayer"
        id="st-commonwealth-player"
        autoplay
        loop
        muted
        webkit-playsinline
        playsinline
        x5-playsinline
        src="https://iv.docbook.com.cn/video/2023/01/11/63bed223b7c431673450019kelianti.mp4"
        style="width:100%;height:100%;object-fit: cover;"
      ></video>
    </div>-->
    <!-- 视频弹窗 -->
    <video-dialog v-if="isVideoShow" :data="videoDialogData" @close="videoClose"></video-dialog>
    <tabbar v-show="showTabbar" style="position: relative"></tabbar>
  </div>
</template>

<script>
// import GuideMask from '@components/GuideMask'
import GlobalLoading from '@components/Common/GlobalLoading'
// ExpertTaskHeader
import ExpertTaskHeader from '@components/ExpertTaskHeader'
import Tabbar from '@components/Tabbar'
import VideoDialog from '@components/VideoDialog'
import Utils from '@utils'
import os from '@utils/os'
import { NativeMessagePush, NativeMessageData } from '@utils/nativeBridge/nativeMessage'

export default {
  components: {
    ExpertTaskHeader,
    GlobalLoading,
    Tabbar,
    VideoDialog
    // GuideMask
  },
  data () {
    return {
      routePath: '',
      isShowHeader: false,
      //   isVideoShow: false,
      socketData: {},
      overTimeTimer: null,
      overTimeCount: 1
    }
  },
  watch: {
    $route (to, from) {
      if (to.name == 'expertTaskList') {
        this.isShowHeader = true
      } else if (to.query.isShowHeader == 1) {
        this.isShowHeader = true
      } else if (from.name == 'expertTaskList' && to.name == 'forgetPassword') {
        this.isShowHeader = false
      } else if (from.name == 'expertTaskList' && to.name == 'taskOrders') {
        this.isShowHeader = false
      } else {
        this.isShowHeader = false
      }

      this.routePath = this.$route.name
    }
  },
  computed: {
    isIEShow () { },
    showLoading () {
      return this.$store.state.common.showLoading
    },
    showTabbar () {
      return this.$store.state.common.showTabbar
    },
    contentWidth () {
      return {
        maxWidth: this.$store.getters.contentWidth
      }
    },
    aliveList () {
      return this.$store.getters.aliveList
    },
    isIE () {
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        console.log(this.routePath)
        if (
          this.routePath == 'ypComment' ||
          this.routePath == 'ypExperts' ||
          this.routePath == 'ypSchedule'
        ) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    userInfos () {
      return this.$store.state.user.userInfos
    },
    isVideoShow () {
      return this.$store.state.common.isVideoDialog
    },
    videoDialogData () {
      return this.$store.state.common.videoDialogData
    }
  },
  created () {
    console.log(this.$route, '111111')
    const ruleOne = Utils.findCssRule('.van-tabs__wrap--scrollable .van-tabs__nav')
    const ruleTwo = Utils.findCssRule('.van-tabs__wrap, .van-tabs__wrap--scrollable')
    let isWindow = false
    let agent = navigator.userAgent.toLowerCase()
    let isMac = /macintosh|mac os x/i.test(navigator.userAgent)
    if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
      isWindow = true
    }
    if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
      isWindow = true
    }

    if (os.isPC() && isWindow) {
      ruleOne.style.cssText = 'overflow: initial !important'
      ruleTwo.style.cssText = 'overflow-x: auto !important'
    }
  },
  mounted () {
    this.getSocket()
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  methods: {
    handleVisibilityChange () {
      if (document.visibilityState === 'visible') {
        // 页面变为可见
        console.log('页面变为可见')
        this.$socket.reopen()
        this.$socket.login()
      } else {
        // 页面变为不可见
        console.log('页面变为不可见')
        this.$socket.close()
      }
    },
    videoClose () {
      this.$store.commit('setIsVideoDialog', false)
      this.overTimeTimer && clearInterval(this.overTimeTimer)
      this.overTimeTimer = null
      this.overTimeCount = 1
    },
    makeMessage (socketData, status) {
      return {
        action: 'sendmsg',
        touserid: socketData.userid,
        userid: localStorage.getItem('userID'),
        toplatform: 'web',
        message: JSON.stringify({
          action: 'videocall',
          userid: localStorage.getItem('userID'),
          callstatus: status,
          videocallreturn: status,
          platform: 'web',
          meetingNumber: socketData.meetingNumber,
          touserid: localStorage.getItem('userID')
        })
      }
    },
    getSocket () {
      this.$socket.login()
      this.$socket.addComponent({
        action: localStorage.getItem('userID'),
        handler: (socketData, sendMessage) => {
          const { callstatus, videocallreturn } = socketData
          console.log(callstatus, videocallreturn, 'socket111111接收参数')
          if (videocallreturn == 'stop') {
            console.log('取消')
            this.$store.commit('setIsVideoDialog', false)
            // this.$toast('对方取消了视频邀请')
            clearInterval(this.overTimeTimer)
            this.overTimeTimer = null
            this.overTimeCount = 1
          } else if (callstatus == 'call') {
            let appIsBusy = this.$nativeBridge.sendMessage(
              new NativeMessageData({
                type: 'appIsBusy'
              })
            )
            // console.log(JSON.parse(appIsBusy), '获取app JSON.parse(appIsBusy)')
            if (JSON.parse(appIsBusy).type == 1) {
              if (
                socketData.meetingNumber == JSON.parse(appIsBusy).gatMeetingId ||
                socketData.meetingNumber == JSON.parse(appIsBusy).zoomMeetingId
              ) {
                sendMessage(this.makeMessage(socketData, 'agree'))
              } else {
                // 会中
                sendMessage(this.makeMessage(socketData, 'overtime'))
              }
            } else if (JSON.parse(appIsBusy).type == 2) {
              // 不在webview 页面
              sendMessage(this.makeMessage(socketData, 'overtime'))
            } else {
              this.socketData = socketData
              this.$store.commit('setVideoDialogData', socketData)
              this.$store.commit('setIsVideoDialog', true)
              console.log(socketData, 'socket接收参数，弹窗弹出事件')
              // 消息通知成功之后发送socket
              sendMessage(this.makeMessage(socketData, 'online'))
              // 处理超时之后发送通知
              clearInterval(this.overTimeTimer)
              this.overTimeTimer = null
              this.overTimeCount = 1
              this.overTimeTimer = setInterval(() => {
                this.overTimeCount++
                console.log(this.overTimeCount, '-this.overTimeCount')
                if (this.overTimeCount >= 60) {
                  clearInterval(this.overTimeTimer)
                  this.overTimeTimer = null
                  this.overTimeCount = 1

                  // 消息通知成功之后发送socket
                  sendMessage(this.makeMessage(socketData, 'overtime'))
                  this.$store.commit('setIsVideoDialog', false)
                }
              }, 1000)
            }
          } else if (videocallreturn == 'agree') {
            this.overTimeTimer && clearInterval(this.overTimeTimer)
            this.overTimeTimer = null
            this.overTimeCount = 1
            this.$nativeBridge.sendMessage(
              new NativeMessagePush({
                pageName: 'joinMeeting',
                params: {
                  zoomMeetingId: socketData.meetingNumber,
                  userName: this.userInfos.name,
                  isAutoAudioLink: 1
                }
              })
            )
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.wrap {
  margin: 0 auto;
  width: 100%;
  height: 100%;
  background: #ececec;
  display: flex;
  flex-direction: column;
}
.content-wrap {
  flex: 1;
  height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.IE-tips {
  min-height: 1.7rem;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  line-height: 1.7rem;
  background: #f95352;
  font-size: 0.5rem;
  color: #fff;
}
.st-commonwealth-player {
  position: absolute;
  top: 100000px;
  left: 100000px;
}
</style>
